import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import MainPage from './MainPage';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import Login from '../views/Login/Login';
import ProgressBar from '../components/ProgressBar/ProgressBar';
import { UserResource } from '../services/Firestore/Resources';
import ErrorBoundary from '../components/ErrorBoundary/ErrorBoundary';
import AuthContext, { User } from '../services/AuthContext/AuthContext';
import { LoadingContextConsumer } from '../services/LoadingContext/LoadingContext';
import Logout from '../views/Logout/Logout';
import QRReaderPage from './QR/QRReaderPage';
import { FlashContainer } from '../components/Flash/Flash';

const useMaintenance = () => {
  const [maintenance, setMaintenance] = useState(false);

  useEffect(() => {
    return firebase
      .firestore()
      .doc('global/maintenance')
      .onSnapshot((doc) => setMaintenance(doc.exists));
  }, []);

  return maintenance;
};

const App = () => {
  const [loggedIn, setLoggedIn] = useState(null);

  useEffect(() => {
    return firebase.auth().onAuthStateChanged((user) => {
      setLoggedIn({ user });
    });
  }, []);

  if (loggedIn === null) return <ProgressBar />;
  if (!loggedIn.user) return <Login />;
  return (
    <UserResource id={loggedIn.user.uid}>
      {(user) => {
        return (
          <AuthContext.Provider value={new User(user)}>
            <MainPage />
          </AuthContext.Provider>
        );
      }}
    </UserResource>
  );
};

export default () => {
  const isMaintenance = useMaintenance();
  if (isMaintenance) {
    return (
      <p style={{ textAlign: 'center' }}>
        Server is underoing maintenance, we'll be back shortly, hopefully.
      </p>
    );
  }
  return (
    <ErrorBoundary>
      <Router>
        <LoadingContextConsumer>
          {(loading) => {
            return (
              <ProgressBar
                style={{
                  display: loading ? 'unset' : 'none',
                  position: 'fixed',
                  top: 0,
                  zIndex: 10000,
                }}
              />
            );
          }}
        </LoadingContextConsumer>
        <FlashContainer style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 10001 }} />
        <Switch>
          <Route path='/logout'>
            <Logout />
          </Route>
          <Route path='/manifests/:manifestId/scan'>
            <QRReaderPage />
          </Route>
          <Route>
            <App />
          </Route>
        </Switch>
      </Router>
    </ErrorBoundary>
  );
};
